import { orderLoop } from "../../global/GlobalVariables";

export function generateLinkSpreadsheet(data, allAdditionalInfoSurebetDecoded, infoCalcFrontEnd) {
  let gameCalculator = {market_mappings:[], time_event: new Date().toISOString(),  title: "", sub_title: "", operation_type: "Arbitragem"};
  for (let index = 0; index < allAdditionalInfoSurebetDecoded.length; index++) {
    let apostas = [];
    let markets = [];

    let typeOdd = allAdditionalInfoSurebetDecoded[index]["typeBet"];
    let odd = infoCalcFrontEnd["odds"][index].replace(",", ".");
    let money = Number(
      infoCalcFrontEnd["qtMoneyBet"][index].replace(",", "."),
    ).toFixed(2);
    let commission = infoCalcFrontEnd["commission"][index].replace(",", ".");

    let marketText = "";
    let infoMarketText = "";
    apostas.push({
      odd: "0.00",
      commission: "0.00",
      stake: "0.00",
      odd_type: "normal",
    });
    markets.push({
        market_event: "",
        info_market_event: "",
    })

    let order = orderLoop[index];

    let game = data[order];

    if(index === 0){
        try{
        gameCalculator["time_event"] = new Date( Number(game["time_milliseconds"]) ).toISOString();
        }catch{
            console.log("");
        }

        gameCalculator["title"] = game["title_event"];
        gameCalculator["sub_title"] = game["sub_title_event"];

    }

    if (game.hasOwnProperty("description_data_market") === true) {
      let market = game["data_market"];
      market["info"].map((item) => {
        marketText += item["value"] + " ";
      });
      marketText = marketText.trim();
      infoMarketText = game["description_data_market"];
    } else {
      let abc =
        '<abbr class="cursor-help" data-bs-delay=\'{"show":150,"hide":0}\' data-bs-html="false" data-bs-toggle="tooltip" data-bs-trigger="hover" data-testid="surebet-leg-market" title="Total acima 3.5 - chutes no alvo time Estudiantes Rio Cuarto">Acima 3.5 - chutes no alvo <span class="minorc">1º o time</span></abbr>';

      const parser = new DOMParser();
      const doc = parser.parseFromString(game["data_market"], "text/html");
      marketText = doc.body.textContent.trim();

      infoMarketText = game["title"];
    }

    apostas[0]["odd"]        = odd;
    apostas[0]["commission"] = commission;
    apostas[0]["odd_type"]   = typeOdd;
    apostas[0]["stake"] = money;

    markets[0]["market_event"] = marketText;
    markets[0]["info_market_event"] = infoMarketText;

    gameCalculator["market_mappings"].push(markets[0]);

    gameCalculator["market_mappings"][index]["positions"] = [apostas[0]];
  }
  let gameCalculatorJSON = JSON.stringify(gameCalculator);

  let partURL = encodeURIComponent(gameCalculatorJSON)

  let endpoint ="/planilha/apostas/nova?data=" + partURL;

    window.open(endpoint, '_blank', 'noopener,noreferrer');

  
}
